if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls, MediaUpload, InnerBlocks } = window.wp.editor;
    const { PanelBody, Button, CheckboxControl, SelectControl } = window.wp.components;

    const COLORS = [
        { label: 'None', value: '' },
        { label: 'Primary', value: 'primary' },
        { label: 'Dark', value: 'dark' },
        { label: 'Light', value: 'light' },
        { label: 'Muted', value: 'muted' },
        { label: 'White', value: 'white' }
    ];

    function getBackgroundClasses(attributes) {
        return getBorderClasses(attributes) +
            (attributes.backgroundColor ? ' has-' + attributes.backgroundColor + '-background-color' : '');
    }

    function getBorderClasses({ borderTop, borderBottom }) {
        return (borderTop ? ' border-top' : '') + (borderBottom ? ' border-bottom' : '') +
            (borderTop || borderBottom ? ' border-2 border-dark' : '');
    }

    registerBlockType('custom-gutenberg/background-image', {
        // built-in attributes
        title: 'Background',
        description: 'Background image with optional top and bottom borders.',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            image: { type: 'string', default: '' },
            imageId: { type: 'number', default: 0 },
            backgroundColor: { type: 'string', default: '' },
            borderTop: { type: 'boolean', default: false },
            borderBottom: { type: 'boolean', default: false }
        },

        // built-in functions
        edit({ attributes, setAttributes }) {
            const { image, imageId, borderTop, borderBottom, backgroundColor } = attributes;

            function onSelectImage(image) {
                const full = image.sizes && image.sizes.full;
                setAttributes({ image: full ? full.url : image.url, imageId: image.id });
            }

            return ([
                <InspectorControls key="settings">
                    <PanelBody title="Background image">
                        <MediaUpload
                            onSelect={ onSelectImage }
                            type="image"
                            allowedTypes={ ['image'] }
                            value={ imageId }
                            render={ ({ open }) => (
                                <div>
                                    { image && <figure><img src={ image } alt="" /></figure> }
                                    <Button onClick={ open } className="button">{ image ? 'Replace image' : 'Select image' }</Button>
                                    { image && <Button onClick={ () => setAttributes({ image: '', imageId: 0 }) } className="button">Remove image</Button> }
                                </div>
                            ) }
                        />
                    </PanelBody>
                    <PanelBody title="Borders">
                        <CheckboxControl label="Top border" checked={ borderTop } onChange={ borderTop => setAttributes({ borderTop: borderTop }) } />
                        <CheckboxControl label="Bottom border" checked={ borderBottom } onChange={ borderBottom => setAttributes({ borderBottom: borderBottom }) } />
                    </PanelBody>
                    <PanelBody title="Background colour">
                        <SelectControl
                            label="Colour"
                            value={ backgroundColor }
                            options={ COLORS }
                            onChange={ backgroundColor => setAttributes({ backgroundColor: backgroundColor }) }
                        />
                    </PanelBody>
                </InspectorControls>,
                <div key="preview" className={ 'cover-image background-image-section section' + getBackgroundClasses(attributes) } style={ { backgroundImage: image ? `url(${image})` : undefined } }>
                    <InnerBlocks templateLock={ false } renderAppender={ InnerBlocks.ButtonBlockAppender } />
                </div>
            ]);
        },

        save({ attributes }) {
            return (
                <div className={ 'lozad cover-image background-image-section section' + getBackgroundClasses(attributes) } data-background-image={ attributes.image }>
                    <InnerBlocks.Content />
                </div>
            );
        },

        // Read the previous saved markup so existing blocks can migrate safely.
        deprecated: [{
            attributes: {
                image: { type: 'string', default: '' },
                overlayTop: { type: 'string', default: '' },
                overlayBottom: { type: 'string', default: '' }
            },
            migrate({ image }) {
                return { image: image, imageId: 0, borderTop: false, borderBottom: false };
            },
            save({ attributes }) {
                const { image, overlayTop, overlayBottom } = attributes;
                return (
                    <div className="lozad cover-image background-image-section section" data-background-image={ image }>
                        { overlayTop && <div className="lozad overlay-image overlay-top" data-background-image={ overlayTop }></div> }
                        <InnerBlocks.Content />
                        { overlayBottom && <div className="lozad overlay-image overlay-bottom" data-background-image={ overlayBottom }></div> }
                    </div>
                );
            }
        }]
    });
}
